import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { TagColor } from '../../types/Tags';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/tags', 'get'>;

type Tag = {
  guid: string;
  name: string;
  color: TagColor;
};

type Result = Tag[];

export const getTagsFactory = (apiClient: ApiClient) => {
  const getTags = async () => {
    const response = await apiClient['/api/tags'].get();
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return response.map((tag) => ({
      guid: tag.guid,
      name: tag.name,
      color: tag.color,
    }));
  };

  return getTags;
};
